import React, { FC } from 'react';
import pageWrapper from '../../hoc/pageWrapper';
import IContentSiteViewModel from '../../interfaces/umbracoNodes/contentSiteViewModel';
import { IPageViewContentModel } from '../../interfaces/umbracoNodes/pageViewModel';
import PageContentSliceMapper from '../pageContentSlice';
import ContentSiteFragment from './contentSiteFragment';

interface Props {
	componentId: number;
	page: IPageViewContentModel;
}

const ContentSite: FC<Props> = ({ page }) => {
	if (page.Values.ContentSlices && page.Values.ContentSlices.length > 0) {
		return <PageContentSliceMapper page={page} />;
	}
	return <ContentSiteFragment page={page as IContentSiteViewModel} />;
};

export default pageWrapper(ContentSite);
